import React, {FC} from "react";
import {Path, Svg, SvgProps} from "react-native-svg";

const ChatIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 50 50" fill="none" {...props}>
            <Path
                d="M25,4.063C12.414,4.063 2.063,12.926 2.063,24C2.063,30.426 5.625,36.094 11,39.719C10.992,39.934 11,40.266 10.719,41.313C10.371,42.605 9.684,44.438 8.25,46.469L7.219,47.906L9,47.938C15.176,47.965 18.754,43.906 19.313,43.25C21.137,43.656 23.035,43.938 25,43.938C37.582,43.938 47.938,35.074 47.938,24C47.938,12.926 37.582,4.063 25,4.063ZM25,5.938C36.715,5.938 46.063,14.09 46.063,24C46.063,33.91 36.715,42.063 25,42.063C22.996,42.063 21.051,41.82 19.219,41.375L18.656,41.25L18.281,41.719C18.281,41.719 15.391,44.977 10.781,45.75C11.613,44.258 12.246,42.871 12.531,41.813C12.93,40.332 12.938,39.313 12.938,39.313L12.938,38.813L12.5,38.531C7.273,35.219 3.938,29.941 3.938,24C3.938,14.09 13.281,5.938 25,5.938Z"
                fill={props.color || "#71706F"}
            />
        </Svg>
    );
};

export default ChatIcon;
